import Swiper from 'swiper/swiper-bundle';

export function initialize() {
  const comicSliderElements = document.querySelectorAll('.js-comic-slider');

  comicSliderElements.forEach((element) => {
    const pageElement = element.parentElement.querySelector('.js-comic-slider-current-page');
    const slider = new Swiper(element, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: element.querySelector('.js-comic-slider-next'),
        prevEl: element.querySelector('.js-comic-slider-prev'),
      },
      scrollbar: {
        el: element.parentElement.querySelector('.js-comic-slider-scrollbar'),
        hide: false,
        draggable: true,
        dragSize: 20,
      },
      breakpoints: {
        980: {
          spaceBetween: 80,
        },
      },
    });
    slider.on('slideChange', swiper => {
      const index = swiper.realIndex + 1;
      pageElement.innerText = index;

      dataLayer.push({
        'event': 'articleVirtualPV',
        'VPVpath': document.location.href,
        'shm_vp': 'manga'
      });

      dataLayer.push({
          'event': 'evTracking',
          'evCategory': 'Ã¦Â¼Â«Ã§ÂÂ»Ã£ÂÂÃ£ÂÂ¥Ã£ÂÂ¢Ã£ÂÂ¼',
          'evAction': 'Ã¦Â¼Â«Ã§ÂÂ»Ã£ÂÂÃ£ÂÂ¥Ã£ÂÂ¢Ã£ÂÂ¼Ã£ÂÂÃ£ÂÂ¼Ã£ÂÂ¸',
          'evLabel': index,
      });
    });
  });
}
